// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.clim-container {
	display: flex;
	flex-direction: column;
	align-items: stretch;
	justify-content: center;
	background: var(--www-color-float-bg2);
	border-radius: 0.7rem;
	margin-bottom: 3.25rem;
}
.clim-info {
	display: flex;
	flex-direction: column;
	font-size: 1.2rem;
	color: var(--meteo-text);
	padding: 1rem;
}
.clim-info h1 {
	margin: 0;
	font-size: 1.4rem;
	font-family: "Inter-Bold", sens-serif;
	font-weight: bold;
}
.clim-info strong {
	font-family: "Inter-Bold", sens-serif;
	font-weight: bold;
}
.clim-info p {
	padding: 0.5rem 0 0.5rem 0;
	font-family: "Inter", sens-serif;
}
.clim-data {
	padding: 1rem;
	display: flex;
	align-items: center;
	font-size: 1.6rem;
	margin: 0rem 1rem;
	color: var(--meteo-text);
}
.clim-container .clim-data:not(:first-child) {
	border-top: solid 1px rgb(255 255 255 / 50%);
}
.clim-container .clim-data:last-child {
	padding-right: 24px;
}
.clim-data p {
	margin: 0.8rem;
	font-size: 1.2rem;
}
.clim-data.icon {
	padding: 0rem;
	margin: 0rem;
	width: 2.4rem;
	height: 2.4rem;
	margin-right: 1.3rem;
	margin-left: -0.7rem;
	background-color: transparent;
}
.flip-open {
	position: absolute;
	right: 0;
	bottom: 0;
	width: 24px;
	height: 24px;
	cursor: pointer;
}
.flip-open.hidden {
	display: none;
}
.flip-close {
	position: absolute;
	right: 0;
	top: 0;
	width: 24px;
	height: 24px;
	cursor: pointer;
}

@media (min-width: 500px) {
	.clim-container {
		margin-bottom: 0;
	}
	.clim-data {
		font-size: 1.2rem;
	}
	.clim-data p {
		margin: 0.3rem;
	}
	.clim-data.icon {
		padding: 0rem;
		width: 2rem;
		height: 2rem;
	}
}
`, "",{"version":3,"sources":["webpack://./src/components/LeftPanel/Indicators/FloatPanelIndicators.css"],"names":[],"mappings":"AAAA;CACC,aAAa;CACb,sBAAsB;CACtB,oBAAoB;CACpB,uBAAuB;CACvB,sCAAsC;CACtC,qBAAqB;CACrB,sBAAsB;AACvB;AACA;CACC,aAAa;CACb,sBAAsB;CACtB,iBAAiB;CACjB,wBAAwB;CACxB,aAAa;AACd;AACA;CACC,SAAS;CACT,iBAAiB;CACjB,qCAAqC;CACrC,iBAAiB;AAClB;AACA;CACC,qCAAqC;CACrC,iBAAiB;AAClB;AACA;CACC,0BAA0B;CAC1B,gCAAgC;AACjC;AACA;CACC,aAAa;CACb,aAAa;CACb,mBAAmB;CACnB,iBAAiB;CACjB,iBAAiB;CACjB,wBAAwB;AACzB;AACA;CACC,4CAA4C;AAC7C;AACA;CACC,mBAAmB;AACpB;AACA;CACC,cAAc;CACd,iBAAiB;AAClB;AACA;CACC,aAAa;CACb,YAAY;CACZ,aAAa;CACb,cAAc;CACd,oBAAoB;CACpB,oBAAoB;CACpB,6BAA6B;AAC9B;AACA;CACC,kBAAkB;CAClB,QAAQ;CACR,SAAS;CACT,WAAW;CACX,YAAY;CACZ,eAAe;AAChB;AACA;CACC,aAAa;AACd;AACA;CACC,kBAAkB;CAClB,QAAQ;CACR,MAAM;CACN,WAAW;CACX,YAAY;CACZ,eAAe;AAChB;;AAEA;CACC;EACC,gBAAgB;CACjB;CACA;EACC,iBAAiB;CAClB;CACA;EACC,cAAc;CACf;CACA;EACC,aAAa;EACb,WAAW;EACX,YAAY;CACb;AACD","sourcesContent":[".clim-container {\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: stretch;\n\tjustify-content: center;\n\tbackground: var(--www-color-float-bg2);\n\tborder-radius: 0.7rem;\n\tmargin-bottom: 3.25rem;\n}\n.clim-info {\n\tdisplay: flex;\n\tflex-direction: column;\n\tfont-size: 1.2rem;\n\tcolor: var(--meteo-text);\n\tpadding: 1rem;\n}\n.clim-info h1 {\n\tmargin: 0;\n\tfont-size: 1.4rem;\n\tfont-family: \"Inter-Bold\", sens-serif;\n\tfont-weight: bold;\n}\n.clim-info strong {\n\tfont-family: \"Inter-Bold\", sens-serif;\n\tfont-weight: bold;\n}\n.clim-info p {\n\tpadding: 0.5rem 0 0.5rem 0;\n\tfont-family: \"Inter\", sens-serif;\n}\n.clim-data {\n\tpadding: 1rem;\n\tdisplay: flex;\n\talign-items: center;\n\tfont-size: 1.6rem;\n\tmargin: 0rem 1rem;\n\tcolor: var(--meteo-text);\n}\n.clim-container .clim-data:not(:first-child) {\n\tborder-top: solid 1px rgb(255 255 255 / 50%);\n}\n.clim-container .clim-data:last-child {\n\tpadding-right: 24px;\n}\n.clim-data p {\n\tmargin: 0.8rem;\n\tfont-size: 1.2rem;\n}\n.clim-data.icon {\n\tpadding: 0rem;\n\tmargin: 0rem;\n\twidth: 2.4rem;\n\theight: 2.4rem;\n\tmargin-right: 1.3rem;\n\tmargin-left: -0.7rem;\n\tbackground-color: transparent;\n}\n.flip-open {\n\tposition: absolute;\n\tright: 0;\n\tbottom: 0;\n\twidth: 24px;\n\theight: 24px;\n\tcursor: pointer;\n}\n.flip-open.hidden {\n\tdisplay: none;\n}\n.flip-close {\n\tposition: absolute;\n\tright: 0;\n\ttop: 0;\n\twidth: 24px;\n\theight: 24px;\n\tcursor: pointer;\n}\n\n@media (min-width: 500px) {\n\t.clim-container {\n\t\tmargin-bottom: 0;\n\t}\n\t.clim-data {\n\t\tfont-size: 1.2rem;\n\t}\n\t.clim-data p {\n\t\tmargin: 0.3rem;\n\t}\n\t.clim-data.icon {\n\t\tpadding: 0rem;\n\t\twidth: 2rem;\n\t\theight: 2rem;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
